export const validation = {
	// Sale type validation
	saleType: {
		required: "Tipo de venta es obligatorio",
		invalid: "Tipo de venta inválido",
	},
	unitOfMeasure: {
		required: "Unidad de medida es obligatoria",
		requiredForVariable: "Unidad de medida es obligatoria para precio variable",
		invalid: "Unidad de medida inválida",
	},
	price: {
		required: "Precio es obligatorio",
		invalid: "Precio es obligatorio",
		min: "El precio debe ser mayor o igual a 0",
	},
	quantity: {
		required: "Cantidad es obligatoria",
		invalid: "Cantidad inválida",
		min: "La cantidad debe ser mayor que 0",
		max: "La cantidad debe ser menor a 10,000",
	},

	// Fiscal data validation
	ncm: {
		required: "NCM es obligatorio",
		invalid: "NCM debe contener entre 4 y 8 dígitos",
	},
	cest: {
		required: "CEST es obligatorio",
		invalid: "CEST debe contener exactamente 7 dígitos",
	},
	fiscalProfile: {
		required: "Perfil fiscal es obligatorio",
		invalid: "Perfil fiscal inválido",
		min: "Perfil fiscal es obligatorio",
	},
	fiscalGroup: {
		required: "Grupo fiscal es obligatorio",
		invalid: "Grupo fiscal inválido",
		min: "Grupo fiscal es obligatorio",
	},

	// General fields
	name: {
		required: "Nombre es obligatorio",
		min: "Nombre es obligatorio",
		max: "El nombre no debe exceder los 100 caracteres",
	},
	productType: {
		required: "Tipo de producto es obligatorio",
		invalid: "Tipo de producto inválido",
		min: "Tipo de producto es obligatorio",
	},
	category: {
		required: "Categoría es obligatoria",
		min: "Categoría es obligatoria",
	},
	sku: {
		invalid: "SKU debe contener solo letras, números, guiones y guiones bajos",
	},
	preparationTime: {
		int: "El tiempo de preparación debe ser un número entero",
		min: "El tiempo de preparación debe ser mayor que 0",
		max: "El tiempo de preparación debe ser menor a 1440 minutos (24 horas)",
	},
	description: {
		max: "La descripción no debe exceder los 500 caracteres",
	},

	// Stock validation
	isStockable: {
		required: "Campo obligatorio",
		invalid: "Valor inválido",
	},
	stockControlledBy: {
		required: "Stock controlado por es obligatorio cuando el producto es almacenable",
		invalid: "Unidad de stock inválida",
	},
	conversionQuantity: {
		required: "Cantidad de conversión es obligatoria",
		min: "La cantidad debe ser mayor que 0",
		max: "La cantidad de conversión debe ser menor a 10,000",
	},
	conversionUnit: {
		required: "Unidad de conversión es obligatoria",
		invalid: "Unidad de conversión inválida",
	},

	// Image validation
	image: {
		required: "Imagen es obligatoria",
		invalid: "Imagen inválida",
	},

	// Mountable product validation
	mountable: {
		title: {
			required: "El título de la etapa es obligatorio",
			min: "El título de la etapa es obligatorio",
		},
		pricing: {
			required: "El método de precio es obligatorio",
			invalid: "Método de precio inválido",
		},
		min: {
			required: "El valor mínimo es obligatorio",
			minValue: "El valor mínimo debe ser mayor o igual a 0",
		},
		max: {
			required: "El valor máximo es obligatorio",
			minValue: "El valor máximo debe ser mayor que 0",
			minGreaterThanMin: "El valor máximo debe ser mayor o igual al mínimo",
		},
		items: {
			min: "Debe haber al menos un artículo en la etapa",
		},
		item: {
			productId: {
				required: "El artículo es obligatorio",
				min: "El artículo es obligatorio",
				duplicate: "Este artículo ya ha sido agregado a esta etapa",
			},
			price: {
				min: "El precio debe ser mayor o igual a 0",
			},
			storageCount: {
				required: "La cantidad deducida es obligatoria",
				minValue: "La cantidad deducida debe ser mayor que 0",
			},
		},
	},
};
